import { jsx } from '@emotion/react/jsx-runtime';
import { SdkContext } from '../contexts/SdkContext.js';

const SdkProvider = _ref => {
  let {
    children,
    sdk
  } = _ref;
  return jsx(SdkContext.Provider, {
    value: sdk,
    children: children
  });
};

export { SdkProvider };
//# sourceMappingURL=SdkProvider.js.map
